import React from "react";
import List from "@mui/material/List";
import {CmLinkableType} from "../../../../types";
import MobileMenuItem from "./MobileMenuItem";
import EasyLangMobileToggleButton from "./EasyLangMobileToggleButton";

interface NavigationLevelContentProps {
    navigationLevel: 0 | 1 | 2;
    itemsToRender: Array<CmLinkableType> | null;
    totalItems: number;
    isItemActive: (item: CmLinkableType, isEasyLangMode?: boolean) => boolean;
    onItemClick: (item: CmLinkableType, onClose: () => void) => void;
    onClose: () => void;
    navigation: any;
    isEasyLangMode?: boolean;
}

const NavigationLevelContent: React.FC<NavigationLevelContentProps> = ({
                                                                           navigationLevel,
                                                                           itemsToRender,
                                                                           isItemActive,
                                                                           onItemClick,
                                                                           onClose,
                                                                           navigation,
                                                                           isEasyLangMode
                                                                       }) => {
    const navigationRoot = navigation?.content?.site?.root;
    const totalItemsToRender = (itemsToRender?.length ?? 0) + (isEasyLangMode && navigationRoot && navigationLevel === 0 ? 1 : 0);
    if (!itemsToRender || totalItemsToRender === 0) return null;
    const items: Array<CmLinkableType> = [];
    if (isEasyLangMode && navigationRoot && navigationLevel === 0) {
        const navigationRootWithoutChildren = {...navigationRoot, children: []};
        items.push(navigationRootWithoutChildren);
    }
    if (itemsToRender) {
        items.push(...itemsToRender);
    }

    return (
        <List disablePadding>
            {items.map((item: CmLinkableType, index: number) => (
                <MobileMenuItem
                    key={item.id}
                    item={item}
                    level={navigationLevel}
                    index={index}
                    totalItems={totalItemsToRender}
                    isActive={isItemActive(item, isEasyLangMode)}
                    onClick={(item) => onItemClick(item, onClose)}
                    onClose={onClose}
                    isEasyLangMode={isEasyLangMode}
                />
            ))}
            {navigationLevel === 0 && <EasyLangMobileToggleButton navigation={navigation}/>}
        </List>
    );
};

export default NavigationLevelContent;